/**
 * This module contains the necessary mechanics to communicate with the browser storage.
 *
 * sessionStorage is used to store the product UUID because sessionStorage is linked to the tab
 * so you can open several applications on several products at the same time (also works on refresh)
 */
import { STORAGE_PRODUCT_UUID_KEY, STORAGE_SITE_UUID_KEY } from './last-braincube';
import { getJwtExpirationDateKey } from '../storage-keys/storage-keys';
function storeUuid(sessionStorageKey, uuid) {
    if (uuid) {
        sessionStorage.setItem(sessionStorageKey, uuid);
    }
}
/**
 * Use this method to scope your JWT with a product UUID before a fetch or refresh
 */
function storeProductUuid(productUuid) {
    storeUuid(STORAGE_PRODUCT_UUID_KEY, productUuid);
}
/**
 * Use this method to scope your JWT with a site UUID before a fetch or refresh
 */
function storeSiteUuid(siteUuid) {
    storeUuid(STORAGE_SITE_UUID_KEY, siteUuid);
}
function storeJwtExpirationDate(key, value) {
    sessionStorage.setItem(key, value);
}
function getJwtExpirationDate(key) {
    const sessionStorageItem = sessionStorage.getItem(key);
    if (sessionStorageItem) {
        return parseInt(sessionStorageItem, 10);
    }
    return 0;
}
function retrieveJwtExpirationDate(scope) {
    return getJwtExpirationDate(getJwtExpirationDateKey(scope));
}
export { storeProductUuid, storeSiteUuid, storeJwtExpirationDate, getJwtExpirationDate, retrieveJwtExpirationDate };
